import React, {useEffect, useState} from 'react';
import PropTypes, {propTypes} from 'prop-types';
import customer from '../../types/customer';
import NovasolApi from '../../api/index';
import Loading from '../Loading';
import CustomerContactInfoCompSelect from './CustomerContactInfoCompSelect';

const CustomerContactInfoCustomerCountry = props => {

  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (loading) {
      NovasolApi.getCountries().then(result => {
        setOptions(result.options);
        setLoading(false);
      });
    }
  }, [loading]);

  return loading ? (
    <Loading loadingWrapClass="loading--country-filter-select"/>
  ) : (
    <CustomerContactInfoCompSelect
      {...props}
      clearable={false}
      errorMessages={{
        'field_is_required': 'The Country field is required',
        'field_is_invalid': 'Your country selection is invalid',
      }}
      label="Select Country"
      name="customerCountry"
      options={options}
      value={props.customer.customerCountry}
    />
  );
};

CustomerContactInfoCustomerCountry.PropTypes = {
  customer: PropTypes.object.isRequired,
  salesMarket: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export default CustomerContactInfoCustomerCountry;
